/**
 * Report an IFrame playback failure to the trusted repair callable.
 * Manual Skip must not call this. The browser does not write provider truth.
 */

import { httpsCallable } from 'firebase/functions';
import { ensureAnonymousAuth, functions } from '../firebase';

export const REPORT_PLAYBACK_FAILURE_CALLABLE = 'reportPlaybackFailure';

export async function reportPlaybackFailure(payload, { callable } = {}) {
  if (!payload || payload.reason !== 'playback_error' || payload.reportable === false) {
    return { ok: false, reason: 'user_skip' };
  }
  try {
    await ensureAnonymousAuth();
    const invoke = callable || httpsCallable(functions, REPORT_PLAYBACK_FAILURE_CALLABLE);
    const response = await invoke(payload);
    return { ok: true, ...(response?.data || {}) };
  } catch (error) {
    return { ok: false, reason: 'unavailable' };
  }
}
